import StoresService from "@/api/services/stores";
import { toCamelCase } from "@estaly/ui";

// Keywords can change while a request is still pending: only the latest request may write its results.
let latestIndexRequest = 0;

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    statuses: () => () => ["active", "inactive", "information_to_be_completed", "pending_verification"],

    statusOrSetup: () => (store) => {
      const isFinalStatus = store.status === "active" || store.status === "inactive";
      return isFinalStatus ? store.status : store.setupStatus || store.status;
    },

    statusBadgeClass: () => (status) => {
      switch (status) {
        case "active":
          return "bg-green-100 text-green-800";
        case "inactive":
          return "bg-red-100 text-red-800";
        case "pending_verification":
          return "bg-blue-100 text-blue-800";
        default:
          return "bg-yellow-100 text-yellow-800";
      }
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.records || [];
      state.currentPage = data.page?.currentPage || 1;
      state.totalPages = data.page?.totalPages || 0;
      state.totalCount = data.page?.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex({ commit }, params = {}) {
      const requestId = ++latestIndexRequest;
      const response = await StoresService.fetchIndex(params);
      const isLatest = requestId === latestIndexRequest;
      if (isLatest && response?.success) commit("setIndex", toCamelCase(response.data));

      return { ...response, isLatest };
    },

    async fetch(_, { id, includes = [] }) {
      const response = await StoresService.fetch(id, includes);
      if (!response?.success) return null;

      return toCamelCase(response.data);
    },

    async update(_, { storeId, data }) {
      return StoresService.update(storeId, data);
    },

    exportXlsx() {
      return StoresService.exportXlsx();
    },

    async updateSalesManager(_context, { storeId, insurerManagerId }) {
      return StoresService.updateSalesManager(storeId, insurerManagerId);
    },
  },
};
